import {deserializeAs} from 'cerialize';

export class CaracteristiquesCompteur {
  @deserializeAs('frequence')
  frequence: string;

  @deserializeAs('client_sensible_mig')
  clientSensibleMig: string;
}
